<template>
  <div class="layout-sidebar">
    <div class="layout-sidebar-wrapper">
      <nav class="sidebar-navigator">
        <div class="sidebar-navigator-btn">
          <a class="sidebar-navigator-normal-btn" @click="showCreateDesign">
            <div class="sidebar-navigator-btn-item">
              <i class="svg-icon"><svg-icon name="add"></svg-icon></i>
              <span>创建设计</span>
            </div>
          </a>
        </div>
        <div class="sidebar-navigator-link">
          <a
            class="sidebar-navigator-normal-link"
            :class="currRouter.path === '/' ? 'active' : ''"
            href="/"
          >
            <div class="sidebar-navigator-link-item">
              <i class="svg-icon"><svg-icon name="space_recommd"></svg-icon></i>
              <span>为你推荐</span>
            </div>
          </a>
          <a
            class="sidebar-navigator-normal-link"
            :class="currRouter.path === '/space' ? 'active' : ''"
            href="/space"
          >
            <div class="sidebar-navigator-link-item">
              <i class="svg-icon"><svg-icon name="space_works"></svg-icon></i>
              <span>我的作品</span>
            </div>
          </a>
        </div>
        <h4 class="sidebar-navigator-title"></h4>
        <div
          class="sidebar-collapse"
          :class="!currRouter.path.match('material') ? 'active-open' : ''"
        >
          <div class="sidebar-collapse-title" @click="onCollapseOpeate">
            <i class="svg-icon">
              <svg-icon name="space_template"></svg-icon>
            </i>
            <span>模板中心</span>
            <span class="sidebar-collapse-title-arrow">
              <i class="svg-icon">
                <svg-icon name="arrow"></svg-icon>
              </i>
            </span>
          </div>
          <div class="sidebar-collapse-body">
            <div class="sidebar-navigator-link">
              <a
                class="sidebar-navigator-normal-link"
                style="display: none"
                :class="currRouter.path.match('FL0') ? 'active' : ''"
                href="/templates/"
              >
                <div class="sidebar-navigator-link-item">
                  <span>所有模板</span>
                </div>
              </a>
              <a
                v-for="(item, ind) in categoryList"
                :key="ind"
                class="sidebar-navigator-normal-link"
                :class="currRouter.path.match('FL' + item.id) ? 'active' : ''"
                :href="'/templates/FL' + item.id"
              >
                <div v-if="item.display" class="sidebar-navigator-link-item">
                  <span>{{ item.name }}</span>
                </div>
              </a>
            </div>
          </div>
        </div>
        <div
          class="sidebar-collapse"
          style="display: none"
          :class="currRouter.path.match('material') ? 'active-open' : ''"
        >
          <div class="sidebar-collapse-title" @click="onSucaiCollapseOpeate">
            <i class="svg-icon">
              <svg-icon name="space_sucai"></svg-icon>
            </i>
            <span>素材中心</span>
            <span class="sidebar-collapse-title-arrow">
              <i class="svg-icon">
                <svg-icon name="arrow"></svg-icon>
              </i>
            </span>
          </div>
          <div class="sidebar-collapse-body">
            <div class="sidebar-navigator-link">
              <a
                class="sidebar-navigator-normal-link"
                style="display: none"
                :class="currRouter.path === '/material' ? 'active' : ''"
                href="/material"
              >
                <div class="sidebar-navigator-link-item">
                  <span>所有素材</span>
                </div>
              </a>
              <a
                class="sidebar-navigator-normal-link"
                :class="currRouter.path.match('/material/mk') ? 'active' : ''"
                href="/material/mk"
              >
                <div class="sidebar-navigator-link-item">
                  <span>免扣素材</span>
                </div>
              </a>
              <a
                class="sidebar-navigator-normal-link"
                :class="currRouter.path.match('/material/bj') ? 'active' : ''"
                href="/material/bj"
              >
                <div class="sidebar-navigator-link-item">
                  <span>高清背景</span>
                </div>
              </a>
              <a
                class="sidebar-navigator-normal-link"
                :class="currRouter.path.match('/material/music') ? 'active' : ''"
                href="/material/music"
              >
                <div class="sidebar-navigator-link-item">
                  <span>音效配乐</span>
                </div>
              </a>
              <a
                style="display: none"
                class="sidebar-navigator-normal-link"
                :class="currRouter.path.match('/material/fonts') ? 'active' : ''"
                href="/material/fonts"
              >
                <div class="sidebar-navigator-link-item">
                  <span>字体库</span>
                </div>
              </a>
            </div>
          </div>
        </div>
        <h4 class="sidebar-navigator-title"></h4>
        <div class="sidebar-navigator-link">
          <a
            class="sidebar-navigator-normal-link"
            :class="currRouter.path === '/navigation' ? 'active' : ''"
            href="/navigation"
          >
            <div class="sidebar-navigator-link-item">
              <i class="svg-icon"><svg-icon name="space_resources"></svg-icon></i>
              <span>资源导航</span>
            </div>
          </a>
          <a
            class="sidebar-navigator-normal-link"
            :class="currRouter.path === '/order' ? 'active' : ''"
            href="/order"
          >
            <div class="sidebar-navigator-link-item">
              <i class="svg-icon"><svg-icon name="space_order"></svg-icon></i>
              <span>我的订单</span>
            </div>
          </a>
          <a
            class="sidebar-navigator-normal-link"
            :class="currRouter.path === '/collect' ? 'active' : ''"
            href="/collect"
          >
            <div class="sidebar-navigator-link-item">
              <i class="svg-icon"><svg-icon name="space_collect"></svg-icon></i>
              <span>我的收藏</span>
            </div>
          </a>
          <a
            class="sidebar-navigator-normal-link"
            :class="currRouter.path === '/set' ? 'active' : ''"
            href="/set"
          >
            <div class="sidebar-navigator-link-item">
              <i class="svg-icon"><svg-icon name="space_set"></svg-icon></i>
              <span>账户设置</span>
            </div>
          </a>
        </div>
      </nav>
    </div>

    <Modal
      class="create-design-modal common-modal"
      v-model:visible="visible"
      :footer="null"
      :closable="false"
      destroyOnClose
    >
      <div class="close" @click="closeModal"><svg-icon name="close"></svg-icon></div>
      <div class="create-design-container">
        <div class="create-design-content">
          <div class="title">自定义尺寸</div>
          <div class="custom-box">
            <InputNumber
              class="custom-input"
              :min="20"
              :max="9000"
              v-model:value="currViewportW"
              placeholder="宽度"
            />
            <svg-icon name="close_black"></svg-icon>
            <InputNumber
              type="primary"
              class="custom-input"
              :min="20"
              :max="12000"
              v-model:value="currViewportH"
              placeholder="高度"
            />
            <Select
              class="custom-select"
              placeholder="请选择尺寸单位"
              :default-value="currViewportType"
              v-model:value="currViewportType"
            >
              <select-option
                v-for="(item, ind) in viewportType"
                :key="ind"
                :value="item.value"
              >
                {{ item.value }}({{ item.label }})
              </select-option>
            </Select>
            <Button type="primary" @click="onCreateDesign">创建设计</Button>
          </div>
          <div class="scene-slider">
            <div class="scene-slider-title"><span>更多场景</span></div>

            <div class="scene-slider-list">
              <div class="scene-slider-list-content">
                <ul>
                  <li
                    class="scene-item"
                    v-for="(item, ind) in scenesList"
                    :key="ind"
                    @click="onCreateDesignOnScenes(item)"
                  >
                    <div><img v-lazy="item.preview" class="scene-img" /><!----></div>
                    <p class="name">{{ item.name }}</p>
                    <p class="size">
                      {{ item.width }}{{ item.unit }} × {{ item.heigh }}{{ item.unit }}
                    </p>
                  </li>
                  <li class="scene-item"></li>
                  <li class="scene-item"></li>
                  <li class="scene-item"></li>
                  <li class="scene-item"></li>
                  <li class="scene-item"></li>
                  <li class="scene-item"></li>
                  <li class="scene-item"></li>
                  <li class="scene-item"></li>
                  <li class="scene-item"></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref, watch } from "vue";
import { MutationTypes, useStore } from "@/store";
import { VIEWPORT_TYPE } from "@/configs/viewport";
// 引入接口
import { EditorService } from "@/api/editor";

import router from "@/router";
import { useRoute } from "vue-router";
import { message } from "ant-design-vue";
export default defineComponent({
  name: "Sidebar",
  setup() {
    const store = useStore();
    const visible = computed(() => store.state.createDesignModalState);
    const collapse = ref(true);
    const sucaiCollapse = ref(false);
    const scenesList = ref([]);
    const viewportType = VIEWPORT_TYPE;
    const currViewportType = ref("px");
    const currViewportW = ref("");
    const currViewportH = ref("");
    const currRouter = ref(router.currentRoute.value);
    const categoryList = ref([]);
    const route = useRoute();
    watch(
      () => route.path,
      () => {
        currRouter.value.path = route.path;
      }
    );
    watch(
      () => visible.value,
      () => {
        if (visible.value) {
          getScenesList();
        }
      }
    );
    const showCreateDesign = () => {
      store.commit(MutationTypes.SET_CRATED_DESIGN_MODAL_STATE, true);
      getScenesList();
    };
    const closeModal = () => {
      store.commit(MutationTypes.SET_CRATED_DESIGN_MODAL_STATE, false);
    };
    const onCollapseOpeate = () => {
      router.push("/templates");
    };
    const onSucaiCollapseOpeate = () => {
      router.push("/material");
    };
    // console.log(scenes, 'scenes')
    const onCreateDesign = () => {
      if (currViewportW.value === "" || currViewportH.value === "") {
        message.error("请填写尺寸！");
        return;
      }
      router.push(
        "/editor?mode=" +
          "create&unit=" +
          currViewportType.value +
          "&width=" +
          currViewportW.value +
          "&height=" +
          currViewportH.value
      );
    };
    const cm = ref(28.3);
    const mm = ref(2.83);
    const width = ref();
    const height = ref();
    const onCreateDesignOnScenes = (item: {
      width: number;
      heigh: number;
      unit: any;
      id: string;
    }) => {
      // vipCheck()
      if (item.unit === "cm") {
        width.value = (item.width * cm.value).toFixed(2);
        height.value = (item.heigh * cm.value).toFixed(2);
      } else if (item.unit === "mm") {
        width.value = (item.width * mm.value).toFixed(2);
        height.value = (item.heigh * mm.value).toFixed(2);
      } else {
        width.value = item.width;
        height.value = item.heigh;
      }
      store.commit(
        MutationTypes.SET_VIEWPORT_RATIO,
        Number(item.heigh) / Number(item.width)
      );
      store.commit(MutationTypes.SET_VIEWPORT_RATIO_WIDTH, Number(width.value));
      store.commit(MutationTypes.SET_VIEWPORT_RATIO_HEIGHT, Number(height.value));
      store.commit(MutationTypes.SET_VIEWPORT_RATIO_WIDTHS, Number(item.width));
      store.commit(MutationTypes.SET_VIEWPORT_RATIO_HEIGHTS, Number(item.heigh));
      store.commit(MutationTypes.SET_VIEWPORT_RATIO_TYPE, item.unit ? item.unit : "px");
      store.commit(MutationTypes.SET_CRATED_DESIGN_MODAL_STATE, false);
      router.push("/editor?mode=" + "create&cid=" + item.id);
    };
    const getScenesList = async () => {
      const params = {
        pageNumber: 1,
        pageSize: 500,
      };
      const res = await EditorService.getScenesList(params);
      const list = ref([]);
      res.data.data.forEach((item: any) => {
        item.checked = false;
        if (item.display) {
          list.value.push(item as never);
        }
      });
      scenesList.value = list.value;
      // console.log( res.data.data, templateList.value, ' templateList.value')
    };
    const template: string | null = window.localStorage.getItem("template");
    if (template) {
      categoryList.value = JSON.parse(template);
    }
    // const vipCheck = async () => {
    //   const loginParams = {
    //     type: 'ppt_content_count',
    //     code: '',
    //   }
    //   const res = await UserService.vipCheck(loginParams)
    //   if (res.data.state === 2) {
    //     message.success(res.data.msg)
    //   }
    //   else {
    //     message.error(res.data.msg)
    //   }
    // }
    return {
      visible,
      collapse,
      sucaiCollapse,
      viewportType,
      currViewportType,
      currViewportW,
      currViewportH,
      currRouter,
      showCreateDesign,
      closeModal,
      onCollapseOpeate,
      onSucaiCollapseOpeate,
      onCreateDesign,
      onCreateDesignOnScenes,
      scenesList,
      categoryList,
    };
  },
});
</script>

<style lang="scss" scoped>
.layout-sidebar {
  position: fixed;
  z-index: 1000;
  top: 55px;
  bottom: 0;
  left: 0;
  width: 190px;
  background: #f6f7f9;
  display: flex;
  flex-direction: column;
  overflow: auto;

  .sidebar-navigator {
    padding-top: 24px;
    .sidebar-navigator-title {
      margin: 20px 0 8px 0;
      padding-left: 24px;
      font-size: 12px;
      font-weight: 500;
      color: #7f8792;
    }
    .sidebar-navigator-link-item {
      position: relative;
      display: flex;
      padding: 10px 0 10px 24px;
      line-height: 20px;
      color: #636c78;
      cursor: pointer;
      transition: background-color 0.2s;
      align-items: center;
    }
    .active .sidebar-navigator-link-item {
      font-weight: 700;
      color: $themeColor !important;
      background: #fff !important;
    }
    .sidebar-navigator-link-item:hover {
      color: #636c78;
      background: #e8eaec !important;
    }
    .svg-icon {
      margin: -1px 10px 0 0;
      svg {
        width: 16px;
        height: 16px;
      }
    }
    .sidebar-collapse {
      .sidebar-collapse-title {
        display: flex;
        padding: 10px 0 10px 24px;
        color: #33383e;
        user-select: none;
        cursor: pointer;
        transition: background-color 0.2s;
        align-items: center;
      }
      .sidebar-collapse-title.active {
        background: #fff;
      }
      .sidebar-collapse-title-arrow {
        position: absolute;
        right: 24px;
        width: 16px;
        height: 16px;
      }
      .sidebar-collapse-title:hover {
        border-radius: 4px;
        color: #000;
        background: #e8eaec;
      }
      .sidebar-collapse-body {
        height: 0;
        overflow: hidden;
        .sidebar-navigator-link-item {
          padding: 10px 0 10px 60px;
          border-radius: 4px;
          color: #636c78;
        }
      }
    }
    .active-open {
      .sidebar-collapse-title-arrow {
        transform: rotate(90deg);
      }
      .sidebar-collapse-body {
        height: auto;
        overflow: visible;
      }
    }
    .sidebar-navigator-btn {
      padding: 0 20px;
      margin: 0 0 25px 0;
    }
    .sidebar-navigator-normal-btn {
      background: $themeColor;
      display: block;
      color: #fff;
      border-radius: 4px;
      height: 46px;
      line-height: 46px;
      text-align: center;
    }
  }
}
.layout-sidebar::-webkit-scrollbar {
  display: none;
}
.create-design-container .custom-box {
  margin: 5px 0 20px 0;
  .svg-icon {
    height: 10px;
  }
  .custom-input,
  .custom-select {
    width: 120px;
    height: 32px;
    margin: 0 10px;
  }
}
.scene-slider-title {
  margin: 0;
}
.scene-slider-title span,
.create-design-content .title {
  font-size: 20px;
  font-weight: bold;
  padding: 10px;
}
.scene-slider-list ul {
  flex-wrap: wrap;
  padding: 0;
  font-size: auto;
  .scene-item {
    margin: 10px;
    flex-grow: 1;
    width: 160px;
  }
  .scene-item > div {
    width: auto;
  }
  .name {
    padding: 5px 0 0 0;
  }
}
</style>
